(ns bp-libs.design-system.components.menu
  "Namespace for different menus"
  (:require [bp-libs.design-system.components.buttons :refer [Button]]
            [bp-libs.design-system.components.icons :as icons]))

(defn tv-menu-item
  [{:keys [on-click tab-index] :as _props}
   {:keys [icon text selected? extra-classes id] :as _icon-props}]
  (let [button-color   "transparent"
        selected-color (when selected? " text-primary-400 hover:text-primary-400 hover:text-primary-400 focus:text-primary-400")]
    [:div {:class     ["flex flex-row items-center first:py-5 leading-8 cursor-pointer group/item outline-none"]
           :tab-index tab-index
           :on-click  (when on-click #(on-click (or id text)))}
     [:div {:class "pr-8 flex"} [Button {:color         button-color
                                         :extra-classes [extra-classes selected-color
                                                         "group-hover/item:bg-white group-focus/item:bg-white"
                                                         (when-not selected? "group-hover/item:text-gray-900 group-focus/item:text-gray-900")]} icon]]
     [:div {:class "h-8 group-hover/item:text-white group-focus/item:text-white group-focus-within:visible group-hover:visible invisible"} text]]))

(defn tv-profile-item
  [name _closed? avatar]
  [:div {:class "flex flex-row items-center"}
   [:div {:class "pr-8 flex"} [:div {:class "w-11 h-11 flex hover:text-gray-900 hover:bg-white focus:ring-white focus:bg-white focus:ring-2 rounded-full bg-gray-900"}
                               (when (seq avatar) [:img {:class "rounded-full" :src avatar}])]]
   [:div {:class "group-focus-within:visible group-hover:visible invisible"}
    [:div [:p {:class "font-normal"} "Olá,"]
     [:p {:class "text-white"} name]]]])

(def tv-default-menu-config
  [{:icon [icons/search] :text "Pesquisar"}
   {:icon [icons/home] :text "Home"}
   {:icon [icons/diamond] :text "Originais BP"}
   {:icon [icons/film] :text "Filmes"}
   {:icon [icons/tv] :text "Lives"}
   {:icon [icons/book-open] :text "Cursos"}
   {:icon [icons/scissors] :text "Cortes"}
   {:icon [icons/plus] :text "Minha Lista"}
   {:icon [icons/log-out] :text "Sair"}])

(defn tv
  "Main TV side menu component"
  {:storybook {:on-item-click {:action "OnClick Button"}
               :name          {:name         "Name"
                               :defaultValue "Pedrinho Dois"
                               :control      {:type "text"}}}}
  [{:keys [react-ref items name class closed? user-avatar tab-index
           on-key-down on-item-click on-mouse-over on-mouse-out on-focus] :as _props}]
  (let [items        (or items tv-default-menu-config)
        middle-items (butlast items)]
    [:div {:ref           react-ref
           :on-mouse-over on-mouse-over
           :on-mouse-out  on-mouse-out
           :on-key-down   on-key-down
           :on-focus      on-focus
           :class         (merge ["flex flex-col justify-between p-10 bg-black text-gray-400 space-y-6 text-2xl font-semibold group"
                                  "w-[5vw] min-w-[100px] max-w-[200px] overflow-hidden"
                                  "focus-within:w-[20vw] hover:w-[20vw]"
                                  "focus-within:min-w-[200px] hover:min-w-[200px]"
                                  "focus-within:max-w-[400px] hover:max-w-[400px]"]
                                 class)}
     [tv-profile-item name closed? user-avatar]
     (into [:div {:class "flex flex-col flex-grow justify-center space-y-5"}]
           (mapv (partial tv-menu-item {:on-click  on-item-click
                                        :tab-index tab-index
                                        :closed?   closed?}) middle-items))
     [:div {:class "flex flex-col"}
      (tv-menu-item {:on-click  on-item-click
                     :tab-index tab-index
                     :closed?   closed?}
                    (last items))]]))

(defn side-menu
  "Generic side menu."
  {:storybook {}}
  [{:keys [action-groups on-item-click tab-index]}]
  [:div {:class ["min-w-96 w-[35%] h-screen"
                 "bg-black/[.65]"
                 "text-white"
                 "space-y-16"]}
   (for [[group-key {:keys [title menu-items] :as action-group}] action-groups]
     ^{:key (hash action-group)}
     [:div {:class ["px-28"
                    "space-y-2"]}
      (when (seq title)
        [:p {:class ["font-bold text-4xl py-6"]} title])
      (for [[item-key item] menu-items]
        ^{:key (hash item)}
        [:div {:class ["font-bold text-2xl"
                       "rounded-md"
                       "cursor-pointer"
                       "px-8 py-4"
                       "outline-none focus:bg-white focus:text-black hover:bg-white hover:text-black"]
               :tab-index tab-index
               :on-click (partial on-item-click group-key item-key)}
         (:title item)])])])
